module.exports = __webpack_public_path__ + "static/media/IMG-6703.0760d283.jpg";